import { useState, useEffect } from 'react';

async function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result as string);
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export function FileInputImage({ file }: { file: File }) {
  const [src, setSrc] = useState<string | null>(null);
  useEffect(() => {
    void fileToBase64(file).then(setSrc);
  }, [file]);

  if (!src) {
    return null;
  }

  return (
    <img src={src} alt={file.name} className="w-full h-full object-contain" />
  );
}
